module.exports = __webpack_public_path__ + "static/media/recommendation7.c63ec27f.png";